/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from "react";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: number | string;
  width?: number | string;
  radius?: number | string;
  circle?: boolean;
  visible?: boolean;
  children?: React.ReactNode;
}

const Skeleton: React.FC<SkeletonProps> = ({
  height,
  width,
  radius,
  circle = false,
  visible = true,
  children,
  className,
  style,
  ...rest
}) => {
  if (!visible && children) {
    return <>{children}</>;
  }

  const resolvedRadius = circle ? "50%" : radius;

  return (
    <div
      // --skeleton-base, not --surface-secondary: the latter carries the same
      // value as the page ground (#faf8f5), so a placeholder painted with it
      // dissolves into whatever it sits on and the screen reads as blank.
      className={`animate-pulse bg-(--skeleton-base,#e5e7eb) ${className ?? ""}`}
      style={{
        height: typeof height === "number" ? `${height}px` : height,
        width: circle
          ? typeof height === "number"
            ? `${height}px`
            : height
          : typeof width === "number"
            ? `${width}px`
            : width,
        borderRadius:
          typeof resolvedRadius === "number"
            ? `${resolvedRadius}px`
            : (resolvedRadius ?? "0"),
        ...style,
      }}
      {...rest}
    />
  );
};

export default Skeleton;
